module.exports = __webpack_public_path__ + "img/wxPay.fa41ec46.png";